// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.Apuestas_boxModal__NyVvP {
  animation: Apuestas_init__5o1Bj 0.5s;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  min-width: 30rem;
  height: 80%;
  min-height: 30rem;
  border-radius: 10px;
  box-shadow: 0px 5px 50px -3px rgba(0, 0, 0, 0.511);
}

.Apuestas_boxModal__NyVvP .Apuestas_exit__Q0Yck {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
}

.Apuestas_boxModal__NyVvP .Apuestas_exit__Q0Yck .Apuestas_exitIcon__QTsXp {
  transition: 0.3s;
}

.Apuestas_boxModal__NyVvP .Apuestas_exit__Q0Yck .Apuestas_exitIcon__QTsXp:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.Apuestas_boxModal__NyVvP .Apuestas_titleModal__IRS-3 {
  width: 90%;
  height: 30px;
  display: flex;
  justify-items: center;
  align-items: center;
}

.Apuestas_boxModal__NyVvP .Apuestas_titleModal__IRS-3 .Apuestas_icon__hfnZF {
  font-size: 30px;
}

.Apuestas_boxModal__NyVvP .Apuestas_titleModal__IRS-3 p {
  font-size: 18px;
  margin-left: 5px;
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 85%;
  margin-top: 0.8rem;
  width: 100%;
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_infoNumbers__EzhdC,
.Apuestas_infoAmount__CAfoJ,
.Apuestas_infoDate__\\+SGFR {
  box-shadow: 0px 5px 10px -3px rgba(0, 0, 0, 0.1);
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_infoNumbers__EzhdC,
.Apuestas_infoAmount__CAfoJ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  width: 90%;
  height: 15%;
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_infoNumbers__EzhdC .Apuestas_row__-I5gN {
  height: 30%;
}
.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_infoAmount__CAfoJ .Apuestas_row__-I5gN {
  height: 30%;
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_infoDate__\\+SGFR {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  width: 90%;
  height: 55%;
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_row__-I5gN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
  height: 9.5%;
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_row__-I5gN p {
  font-size: 14px;
}

.Apuestas_boxModal__NyVvP .Apuestas_info__JvukF .Apuestas_row__-I5gN .Apuestas_span__TwSOK {
  font-size: 14px;
  font-weight: 400;
}

@keyframes Apuestas_init__5o1Bj {
  0% {
    opacity: 0;
    transform: translate(-50%, -60%);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Premios/Tabs/Modales/ModalApuestas/Apuestas.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,oCAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.5s;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 30%;\n  min-width: 30rem;\n  height: 80%;\n  min-height: 30rem;\n  border-radius: 10px;\n  box-shadow: 0px 5px 50px -3px rgba(0, 0, 0, 0.511);\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 90%;\n  height: 30px;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n}\n\n.boxModal .titleModal .icon {\n  font-size: 30px;\n}\n\n.boxModal .titleModal p {\n  font-size: 18px;\n  margin-left: 5px;\n}\n\n.boxModal .info {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  height: 85%;\n  margin-top: 0.8rem;\n  width: 100%;\n}\n\n.boxModal .info .infoNumbers,\n.infoAmount,\n.infoDate {\n  box-shadow: 0px 5px 10px -3px rgba(0, 0, 0, 0.1);\n}\n\n.boxModal .info .infoNumbers,\n.infoAmount {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  border-radius: 10px;\n  width: 90%;\n  height: 15%;\n}\n\n.boxModal .info .infoNumbers .row {\n  height: 30%;\n}\n.boxModal .info .infoAmount .row {\n  height: 30%;\n}\n\n.boxModal .info .infoDate {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  border-radius: 10px;\n  width: 90%;\n  height: 55%;\n}\n\n.boxModal .info .row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 95%;\n  height: 9.5%;\n}\n\n.boxModal .info .row p {\n  font-size: 14px;\n}\n\n.boxModal .info .row .span {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translate(-50%, -60%);\n  }\n  100% {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `Apuestas_boxModal__NyVvP`,
	"init": `Apuestas_init__5o1Bj`,
	"exit": `Apuestas_exit__Q0Yck`,
	"exitIcon": `Apuestas_exitIcon__QTsXp`,
	"titleModal": `Apuestas_titleModal__IRS-3`,
	"icon": `Apuestas_icon__hfnZF`,
	"info": `Apuestas_info__JvukF`,
	"infoNumbers": `Apuestas_infoNumbers__EzhdC`,
	"infoAmount": `Apuestas_infoAmount__CAfoJ`,
	"infoDate": `Apuestas_infoDate__+SGFR`,
	"row": `Apuestas_row__-I5gN`,
	"span": `Apuestas_span__TwSOK`
};
export default ___CSS_LOADER_EXPORT___;
